import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './Videos.css';

class Videos extends Component {
    constructor(props) {
        super(props);
        this.filterChanged = this.filterChanged.bind(this);

        const { videos = '', videos_title } = this.props.property;

        let reorderVideo = '';

        if (videos) {
            let filtered = [];

            videos.forEach(function (item) {
                filtered.push({
                    ...item.video,
                    value: item.video.video_link,
                    label: item.video.video_name,
                });
            });
            reorderVideo = filtered.sort((a, b) => a.video_name.toLowerCase().localeCompare(b.video_name.toLowerCase())); 
        }


        this.state = {
            videos_title,
            videos: reorderVideo,
            selectedOption: {
                label: 'SELECT A VIDEO',
                value: reorderVideo[0] ? reorderVideo[0].video_link : '',
                video_link: reorderVideo[0] ? reorderVideo[0].video_link : '',
            },
        };
    }

    filterChanged(data) {
        if (data.value !== '') {
            this.setState(() => ({
                selectedOption: data,
            }));
        }
    }

    render() {
        return (
            this.state.videos.length > 0 ? <div className="videos">
                <div className="section">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-offset-1 is-6-tablet is-7-desktop is-7-widescreen">
                                <h3 className="big-title border-left-yellow">
                                    {this.state.videos_title}
                                </h3>
                            </div>
                            {this.state.videos.length > 1 && <div className="column">
                                <Select
                                    instanceId="videos-select"
                                    className="select-wrapper"
                                    classNamePrefix="react-select"
                                    placeholder={this.state.selectedOption.label}
                                    name="filter-by-suite"
                                    options={this.state.videos}
                                    isSearchable={false}
                                    value={this.state.selectedOption}
                                    onChange={this.filterChanged}
                                />
                            </div> }
                        </div>
                    </div>
                </div>
                <div className="section video-suite-section">
                    <div className="container">
                        <div className="iframe-wrapper">
                            <div className="placeholder-content">
                                <div className="loader"></div>
                                <iframe title="iframe-videos" src={this.state.selectedOption.video_link} frameBorder='0' allowFullScreen allow='xr-spatial-tracking'></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div> : null
        );
    }
}

Videos.propTypes = {
    property: PropTypes.object.isRequired,
};

export default Videos;
